import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

//
// clicked article
// scrolled
// open in a new tab

import styles from './styles.module.scss';
import { fetchNews, selectShouldFetch, selectNewsData } from './slice';
import { useDispatch, useSelector } from 'react-redux';
import { timeInMs } from '../../../shared';
// import { trackAmplitudeEvent } from '../../../shared/analytics';

const formatDuration = (date: string) => {
  const duration = Date.now() - Number(new Date(date));
  if (duration >= (timeInMs.day * 0.9)) {
    const days = Math.round(duration / timeInMs.day);
    return `${days} hour${days > 1 ? 's' : ''}`;
  }

  if (duration >= (timeInMs.hour * 0.9)) {
    const hrs = Math.round(duration / timeInMs.hour);
    return `${hrs} hour${hrs > 1 ? 's' : ''}`;
  }

  const minutes = Math.round(duration / timeInMs.minute);
  return `${minutes} ${minutes > 1 ? 'minutes' : 'minute'}`;
}

const News = () => {
  const dispatch = useDispatch();
  const shouldFetch = useSelector(selectShouldFetch);
  const data = useSelector(selectNewsData);

  const [isScrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchNews());
    }
  }, []);

  // const handleClickLink = useCallback(() => {
  //   trackAmplitudeEvent(`User clicked news`, {
  //     category: 'News',
  //   });
  // }, []);

  const refViewed = useRef<boolean>(null);
  const ref = useRef<HTMLDivElement>();
  useEffect(() => {
    if (!ref.current) return;

    const $html = document.querySelector('html');
    const callback = () => {
      setScrolled($html.scrollTop >= 200);

      if ($html.scrollTop < 400 || refViewed.current) return;

      refViewed.current = true;
      // trackAmplitudeEvent(`User scrolled news`, {
      //   category: 'News',
      // });
    };

    if (refViewed.current === null) {
      refViewed.current = false;
      document.addEventListener('scroll', callback, { passive: true });
    }

    // ref.current.querySelectorAll('a').forEach((el) => {
    //   el.removeEventListener('click', handleClickLink);
    //   el.addEventListener('click', handleClickLink);
    // });


  }, [data]);

  if (!data) return null;

  return (
    <div className={`${styles.root} ${isScrolled ? styles.scrolled : ''}`} ref={ref}>
      <div className={styles.scrollLabel}>
        Scroll for News

        <KeyboardArrowDownIcon />
      </div>

      <div className={styles.container}>
        <div className={styles.newsList}>
          {data.subCards
            .map((card) => {
              if (card.type === 'article') {
                return (
                  <a
                    key={card.id}
                    href={card.url}
                    className={styles.newsEl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className={styles.image} style={{ backgroundImage: `url(${card.images?.[0].url})` }} />
                    <div className={styles.content}>
                      <div className={styles.provider}>
                        <img src={card.provider.logoUrl} alt='' width={16} height={16} />
                        {card.provider.name}

                        <span>&nbsp;·&nbsp;</span>

                        <span>{formatDuration(card.publishedDateTime)}</span>
                      </div>

                      <h2 className={styles.title}>{card.title}</h2>
                    </div>
                  </a>
                );
              }

              if (card.type === 'slideshow') {
                return (
                  <>
                    {[card.slides[0]]
                      .filter((slide) => !!slide.title?.trim())
                      .map((slide, index) => (
                        <a key={index} className={styles.slideEl} href={card.url}>
                          <div className={styles.image} style={{ backgroundImage: `url(${slide.image.url})` }} />

                          <div className={styles.content}>
                            <h2 className={styles.title}>{slide.title}</h2>
                            <div className={styles.description} dangerouslySetInnerHTML={{ __html: slide.body }} />
                          </div>
                        </a>
                      ))}
                  </>
                );
              }

              return null;
            }).filter(Boolean)}
        </div>
      </div>
    </div>
  );
};

export default News;
